import React from "react";

interface FaqSkeletonProps {
  itemsCount?: number;
}

const FaqSkeleton: React.FC<FaqSkeletonProps> = ({ itemsCount = 5 }) => {
  return (
    <div className="max-w-screen-2xl w-full place-self-center max-md:p-4">
      {[...Array(itemsCount)].map((_, index) => (
        <div key={index} className="bg-content3 rounded-xl flex flex-col my-4 animate-pulse">
          <div className="flex flex-row p-5 justify-between items-center">
            <div className="h-6 bg-content2 rounded w-3/4"></div>
            <div className="w-10 h-10 bg-content2 rounded-lg"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FaqSkeleton;